const defaultTheme: string = ``;

export default defaultTheme;
